// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import EventFormTabs from './EventFormTabs/EventFormTabs';

const EventFormWrapper = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  party,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  typeForCreate,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  ideas,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  addEventToState,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  closeModal,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  children,
}) => {
  const isTabsShown = typeForCreate === 'Event';
  return (
    <>
      {isTabsShown ? (
        <EventFormTabs
          party={party}
          ideas={ideas}
          addEventToState={addEventToState}
          closeModal={closeModal}
        >
          {children}
        </EventFormTabs>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export default EventFormWrapper;
